// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.already-completed-step p::first-letter{text-transform:capitalize}`, "",{"version":3,"sources":["webpack://./src/containers/MultistepForm/AlreadyCompletedStep/styles.scss"],"names":[],"mappings":"AAEE,wCACE,yBAAA","sourcesContent":["\n.already-completed-step{\n  p::first-letter{\n    text-transform: capitalize\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
